<template>
  <div>
    <div class="elections-list-title" v-if="title">{{ title }}</div>
    <div class="elections-list">
      <div
        class="elections-list-item"
        v-for="(election, index) in elections"
        :key="`${routeName}-${index}`"
        @click="$router.push({ name: routeName, params: { raceId: election.raceId } })">
        {{ election.raceName }}
      </div>
    </div>
  </div>
</template>

<script>
const props = {
  title: {
    type: String,
    required: false
  },
  elections: {
    type: Array,
    required: true
  },
  routeName: {
    type: String,
    required: true
  }
}
export default {
  props
}
</script>

<style>
.elections-list {
  /* max-height: 120px;
  overflow-y: auto; */
  margin: 5px 0 10px;
  padding-top: 5px;
  border-top: 1px solid var(--border-color);
}

.elections-list-title {
  font-weight: 700;
  font-size: 13px;
  opacity: 0.7;
}

.elections-list-item {
  cursor: pointer;
  font-size: 14px;
}

.elections-list-item:hover {
  opacity: 0.7;
}

@media only screen and (max-width: 960px) {
  .elections-list-title {
    font-size: 16px;
  }

  .elections-list-item {
    font-size: 18px;
    margin: 5px 0;
  }
}
</style>
